// Workout templates API — full CRUD.
import { http } from "./http";
import type { OkResponse, Template, TemplateInput } from "./types";

export const templatesApi = {
  list: (signal?: AbortSignal) =>
    http.get<Template[]>("/templates", undefined, signal),
  get: (id: number, signal?: AbortSignal) =>
    http.get<Template>(`/templates/${id}`, undefined, signal),
  create: (body: TemplateInput) => http.post<Template>("/templates", body),
  update: (id: number, body: TemplateInput) =>
    http.patch<Template>(`/templates/${id}`, body),
  remove: (id: number) => http.del<OkResponse>(`/templates/${id}`),
};
